import React from "react";
import Slider from "react-slick";
import Testimonial from "../Items/Testimonial";
import useMediaQuery from "../../hooks/useMediaQuery";

const testimonialsData = [
  {
    id: 1,
    content:
      "Lucas is an outstanding and strong developer. He is smart, result oriented and self driven person. He is able to deliver tons of value with minimum of supervision, a quality that’s valuable in the tech industry. He is a leader and his background in math and engineering makes are powerful weapons in his arsenal. ",
    authorImage: "images/customers/luis.jpeg",
    authorName: "Luis Diaz",
    authorStatus: "CEO at Dcnearshore.com",
  },
  {
    id: 2,
    content:
      "He learns new technologies really quick and have a natural talent for leading. He can develop with ease, any given interface, especialy for mobile. He had great sinergy with our UX Team. Aways trys to help and is really open to opinions. He would be a great asset for any team.",
    authorImage: "images/customers/geraldo.jpeg",
    authorName: "Geraldo Netto",
    authorStatus: "UX/UI Tech lead at Cedro Tech",
  },
  {
    id: 8,
    content:
      "The time he spent at our company was always well committed to the tasks assigned to him. I don't have any negative feedback to share about Lucas.",
    authorImage: "images/customers/paul.jpeg",
    authorName: "Paul Nichols",
    authorStatus: "Director of Engineering at HomeLight",
  },
  {
    id: 3,
    content:
      "Lucas is an easy-going person, a multidisciplinary professional willing and committed to delivering results within the projects in which he is involved. He has a thirst for knowledge, an ambition to grow and a desire to learn!",
    authorImage: "images/customers/gabriel.jpeg",
    authorName: "Gabriel Ferreira",
    authorStatus: "CTO at Dcnearshore.com",
  },
  {
    id: 4,
    content:
      "Lucas was a person who sought to have autonomy to solve problems, active thinking, initiative, communication and collaboration in helping less experienced Developers. Also another ability of Lucas is that he was a fast learner, he had the initiative to update himself and keep learning.",
    authorImage: "images/customers/jonata.jpeg",
    authorName: "Johnathan Cruz",
    authorStatus: "CTO at Predict.info",
  },
  {
    id: 5,
    content:
      "He was super part of the team. He spent most of his time on code but had the initiative to speak and respond promptly to the customer. In addition to all his demands, he had the challenge of staying with the Scrum Master activities for a period that I had to leave due to health problems and he excelled very well in an effective way with all the activities intended for him.",
    authorImage: "images/customers/raissa.jpeg",
    authorName: "Raíssa Thábata",
    authorStatus: "Scrum Master at Cedro Tech",
  },
];

function Testimonials() {
  const isMobile = useMediaQuery(768);
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 2,
    slidesToScroll: 1,
  };

  return (
    <div className="testimonials-wrapper">
      <Slider {...settings} className="padding-slider">
        {testimonialsData.map((testimonial) => (
          <Testimonial testimonial={testimonial} key={testimonial.id} />
        ))}
      </Slider>
    </div>
  );
}

export default Testimonials;
